import { Pipe, PipeTransform } from "@angular/core";

const MONTH_NAMES: Array<string> = [
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "May",
  "Jun",
  "Jul",
  "Aug",
  "Sep",
  "Oct",
  "Nov",
  "Dec",
];

const DATE_SEP = "-";
const TIME_SEP = ":";

@Pipe({
  name: "bfxDate",
  standalone: false,
})
export class BfxDatePipe implements PipeTransform {
  transform(time: number, format: string = "longDateAndTime"): string {
    let dateObj: Date = new Date(time);

    let day: string = dateObj.getDate().toString();
    let month: string = MONTH_NAMES[dateObj.getMonth()];
    let year: string = dateObj.getFullYear().toString().substring(2);
    let hour: string = this.addZero(dateObj.getHours(), 2);
    let minutes: string = this.addZero(dateObj.getMinutes(), 2);
    let seconds: string = this.addZero(dateObj.getSeconds(), 2);
    let milliseconds: string = this.addZero(dateObj.getMilliseconds(), 3);

    let shortDate: string =
      day +
      DATE_SEP +
      month +
      DATE_SEP +
      year +
      " " +
      hour +
      TIME_SEP +
      minutes +
      TIME_SEP +
      seconds;
    if (format === "mediumDateAndTime") return shortDate;
    else if (format === "longDateAndTime") return shortDate + "." + milliseconds;
    else return "";
  }

  private addZero(x, n) {
    while (x.toString().length < n) {
      x = "0" + x;
    }
    return x;
  }
}
